import Game from './game';

document.addEventListener('DOMContentLoaded', () => {
  const game = new Game();

  handleInput(game);
});

const handleInput = (game) => {
  document.getElementsByTagName('body')[0].addEventListener('keydown', (e) => {
    game.handleInput(e);
  });
};



//////////////////
// WEBPACK FOOTER
// ./lib/javascripts/falling_words.js
// module id = 1
// module chunks = 0